import parseDialogue from "../../util/parseDialogue";

export const SuperphreakL3 = parseDialogue(`
superphreak:l3:100-300

#100 Hey, good work. The logs you just found will be really helpful. We need all the data we can get to figure out what's going on.
>200 What should I do next?

#200 Hmm, just keep hacking ~ ~~~ nodes to see if you can ~~~~~ some more logs. Watch out for corporate ~~~~~~~~ and don't forget what you learned using Bit-Man. L8R.
>300 Later
`);
